module.exports = __webpack_public_path__ + "media/shooting_stars.b0d89e28.mp3";